module.exports = __webpack_public_path__ + "static/media/swingMainImg.27f4edc6.jpeg";